import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import useScrollHandlerGroup from '@hooks/useScrollHandlerGroup';
import H5 from '@base/H5/H5';
import { useIsMobile } from '@stores/AppCommonData';
import { allSections, headerSections } from '../sections';
import { Fonts, mobile } from '../../../../styleConstants';

const SectionName = styled(H5)`
  color: ${({ $isActive }) =>
    $isActive ? 'var(--color-i-black-3)' : 'var(--color-i-violet-7)'};
  cursor: pointer;
  font-weight: ${({ $isActive }) =>
    $isActive ? Fonts.SEMIBOLD : Fonts.REGULAR};
  text-align: center;
  @media only screen and (min-width: ${mobile.maxWidth}) {
    font-weight: ${Fonts.SEMIBOLD};
  }
`;

const Sections = ({ headerRefs }) => {
  const isMobileDevice = useIsMobile();
  const refs = allSections.map((section) => ({
    ref: headerRefs[section.id],
    shrinkPos: isMobileDevice ? 40 + 30 : 72 + 70,
    id: section.id
  }));
  const { activeStatuses, scrollToElement } = useScrollHandlerGroup(refs);
  const onSectionClick = (ref, id) => () => {
    const element = ref.current?.parentElement;
    if (element) {
      scrollToElement(element, id, {
        offsetTop: isMobileDevice
          ? 40
          : ((window.innerWidth - ref.current.getBoundingClientRect().width) /
              2) *
            (window.innerHeight / window.innerWidth)
      });
    }
  };
  return (
    <>
      {headerSections.map((section, index) => (
        <SectionName
          key={section.id}
          onClick={onSectionClick(headerRefs[section.id], section.id)}
          $isActive={activeStatuses[index]}
        >
          {section.name}
        </SectionName>
      ))}
    </>
  );
};

Sections.propTypes = {
  headerRefs: PropTypes.objectOf(PropTypes.object).isRequired
};

export default Sections;
